import gql from 'graphql-tag';

export const UPDATE_VENDOR_OPPORTUNITY = gql`
  mutation UpdateVendorOpportunity($VOId: String!, $fieldsObj: UpdateVendorOpportunityInput!) {
    updateVendorOpportunity(VOId: $VOId, fieldsObj: $fieldsObj)
  }
`;
